import { Link } from "react-router-dom";

export default function SiteIntro() {
  return (
    <section aria-labelledby="intro-title" className="w-full px-4 md:px-6">
      <div className="rounded-lg border hairline bg-background-900/60 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_1fr]">
          <div className="p-5 md:p-8">
            <h2 id="intro-title" className="font-heading text-xl md:text-2xl font-semibold text-foreground-50">
              关于禁漫天堂
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-300">
              禁漫天堂定位为动漫漫画资源聚合入口，专注于把分散在各处的作品信息整理成可检索、可筛选、可追溯的结构化目录。我们不做内容的上传者，而是做阅读路径的组织者：从焦点推荐到分类探索，从关键词搜索到多维筛选，任何一次查找都尽量控制在三步以内完成。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-400">
              站内的作品介绍、章节目录与资源格式说明均由编辑团队整理校对；所有下载入口与分享行为在当前版本仅为交互演示，正式的数据分发与阅读页将在后续版本接入。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2.5">
              <Link
                to="/about"
                className="h-9 px-4 rounded-md bg-accent-500 text-background-950 text-xs font-medium flex items-center gap-1.5 hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                了解团队与联系
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/about#faq"
                className="h-9 px-4 rounded-md border hairline text-xs text-foreground-200 flex items-center gap-1.5 hover:border-accent-500/50 hover:text-accent-300 transition-colors whitespace-nowrap"
              >
                常见问题
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-px bg-background-700/50 border-t lg:border-t-0 lg:border-l hairline">
            {[
              { icon: "ri-search-eye-line", title: "全文检索", desc: "标题 / 作者 / 标签 / 简介全覆盖" },
              { icon: "ri-filter-3-line", title: "多维筛选", desc: "状态 · 地区 · 年份 · 排序" },
              { icon: "ri-download-2-line", title: "资源说明", desc: "格式、体积与合集范围标注" },
              { icon: "ri-shield-star-line", title: "正版倡导", desc: "内容演示为主，支持正版阅读" },
            ].map((item) => (
              <div key={item.title} className="bg-background-900/85 p-4 md:p-5">
                <span className="w-8 h-8 rounded-md flex items-center justify-center bg-secondary-900/70 text-secondary-200">
                  <i className={`${item.icon} text-sm`} />
                </span>
                <h3 className="mt-2.5 text-[13px] font-medium text-foreground-100">{item.title}</h3>
                <p className="mt-1 text-[11px] leading-5 text-foreground-400">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}